import React, { useState, useRef, useEffect } from 'react';
import { Dialog, Stack, Typography, DialogActions, Button, IconButton, TextField, useTheme, MenuItem } from '@mui/material';
import * as yup from 'yup';
import { Formik, Form } from 'formik';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import appapi from '../../../../api/apiClient';
import { showmessage } from '../../../../utils/toastr';
import { setLoading } from '../../../../redux/features/appSlice';
import { useSelector, useDispatch } from 'react-redux';
import FormTextField from '../../../../components/FormTextField';
import Transition from '../../../../components/Transition';
import ModalHeader from '../../../../components/ModalHeader';
import FormSelectField from '../../../../components/FormSelectField';
import { initCompanyDetails } from '../../../../redux/features/authSlice';

/**
 * dialog style
 */
const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

/**
 * Validation Schema
 */
const validationSchema = yup.object({
  companyName: yup.string('Company Name').min(3, 'Company Name should be atleast 3 characters').max(100, 'Maximum Character Limit 100').required(' '),
  regAddress: yup.string('Company Name').min(1, 'Company Name should be atleast 3 characters').max(300, 'Maximum Character Limit 300').required(' '),
  countryName: yup.string('Country Name').required(' '),
  stateName: yup.string('state Name').required(' '),
});

export default function EditOrganization({ companyDetails, onModelHandleClose, modelOpen }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { countryList } = useSelector((state) => state.layout);
  const [countryId, setCountryId] = useState(null);
  const [stateList, setStateList] = useState([]);

  useEffect(() => {
    console.log(companyDetails)
    if (companyDetails?.countryName) {
      const idObj = countryList.filter((res) => res.countryName === companyDetails?.countryName)[0];
      if (idObj) {
        setCountryId(idObj._id);
      }
    }
  }, [companyDetails?.countryName]);

  useEffect(() => {
    if (countryId) {
      getStateList();
    }
  }, [countryId]);

  const getStateList = async () => {
    const response = await appapi.get(`common/state/${countryId}`);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setStateList(data.response || []);
      } else {
        setStateList([]);
      }
    }
  };

  const handleClose = () => {
    onModelHandleClose(false);
  };


  const handleEditCompany = async (values) => {
    dispatch(setLoading(true));
    const response = await appapi.put(`admin-portal/organisation/${companyDetails?._id}`, values);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        dispatch(initCompanyDetails());
        showmessage(data.message);
        // dispatch(initGodownList());
      } else {
        showmessage(data.message, 'error');
      }
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };


  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      // TransitionComponent={Transition}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        // className="!h-[100%]"
        style={{ backgroundColor: '#F0F0F0' }}
      >
        <ModalHeader
          label={`EDIT ORGANISATION DETAILS`}
          onClose={() => onModelHandleClose(false)}
        />
        <Formik
          innerRef={formRef}
          enableReinitialize={true}
          initialValues={{
            companyName: companyDetails?.companyName || '',
            regAddress: companyDetails?.regAddress || '',
            countryName: companyDetails?.countryName || '',
            stateName: companyDetails?.stateName || '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => { handleEditCompany(values) }}
        >
          {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue }) => (
            <Form autoComplete="off">
              <Stack
                style={{ backgroundColor: 'white', borderRadius: '8px' }}
                className="m-[15px] p-[16px]"
              >
                <Typography
                  className="fw-medium ff-Roboto fs-14"
                  style={{ marginBottom: '20px' }}
                >
                  Organisation details
                </Typography>
                <Stack>
                  <FormTextField
                    placeholder={'Company Name'}
                    outlineLabel={'Company Name'}
                    name="companyName"
                    requiredMark={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 101 }}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    placeholder={'Address'}
                    outlineLabel={'Address'}
                    name="regAddress"
                    requiredMark={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 301 }}
                  />
                </Stack>
                <Stack>
                  <FormSelectField
                    name="countryName"
                    label={'Country *'}
                    onSelect={(e) => {
                      setFieldValue('stateName', undefined);
                      const idObj = countryList.filter((res) => res.countryName === e)[0];
                      if (idObj) {
                        setCountryId(idObj._id);
                      }
                    }}
                  >
                    {countryList?.map((item) => (
                      <MenuItem
                        key={item.countryName}
                        value={item.countryName}
                      >
                        <div style={{ textTransform: 'capitalize' }}>{item.countryName}</div>
                      </MenuItem>
                    ))}
                  </FormSelectField>
                </Stack>
                <Stack>
                  <FormSelectField
                    name="stateName"
                    label={'State *'}
                  >
                    {stateList?.length === 0 && <MenuItem disabled value="">
                      <em>No Data Found</em>
                    </MenuItem>}
                    {stateList?.map((item) => (
                      <MenuItem
                        key={item.stateName}
                        value={item.stateName}
                      >
                        <div style={{ textTransform: 'capitalize' }}>{item.stateName}</div>
                      </MenuItem>
                    ))}
                  </FormSelectField>
                </Stack>
              </Stack>

              <DialogActions
                className="!mt-[244px] h-[66px] !justify-end p-[0px] sticky bottom-[0]"
                style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
              >
                <Button
                  sx={[
                    dialogButtonCancel,
                    {
                      color: theme.palette.primary.main,
                      borderColor: '#14285A33',
                      backgroundColor: '#14285A1A',
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                        // borderColor: theme.palette.secondary.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', marginLeft: '80px', height: '40px' }}
                  variant="outlined"
                  onClick={() => {
                    handleClose();
                    //   setConfirmVal('');
                  }}
                >
                  Cancel
                </Button>
                <Button
                  sx={[
                    buttonStyle2,
                    {
                      color: theme.palette.background.main,
                      backgroundColor: theme.palette.primary.dark,
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', height: '40px' }}
                  disabled={!(dirty && isValid)}
                  type="submit"
                  variant="contained"
                >
                  {companyDetails?.type === 'add' ? `ADD` : `UPDATE`}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
